// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {DryRunStickyEndValidationResult} from 'assembly/_golden-gate';
import asm from 'assembly/Asm';
import PrimerAssemblyOptionsView from 'assembly/tabs/primer-assembly/backbone/OptionsView';
import PrimerAssemblyTabView from 'assembly/tabs/primer-assembly/backbone/PrimerAssemblyTabView';
import {StickyEndsProps} from 'assembly/tabs/primer-assembly/StickyEnds';
import {FragmentResult} from 'BioJS';
import {DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import FileStates from 'FileStates';
import * as colors from 'lib/Colors';
import * as sequtil from 'molbio/SeqUtil';

function checkAssembly(sequence: Sequence): DryRunStickyEndValidationResult {
  const _sequence = sequence._sequence();

  const stickyEndRanges = asm.goldenGate.stickyEndRanges(_sequence);
  const junctionStickyEnds = stickyEndRanges
    .map(({upstreamFragment, downstreamFragment, start, end}) => {
      const upstreamName = upstreamFragment.parent()?.name;
      const downstreamName = downstreamFragment.parent()?.name;
      return new asm.goldenGate.StickyEnd(
        stickyEndBases(sequence, upstreamFragment, downstreamFragment, start, end),
        `${upstreamName} / ${downstreamName}`
      );
    })
    // Remove empty strings (occurs if the sticky ends are not available).
    .filter((stickyEnd) => stickyEnd.bases.length > 0);

  // TODO(gg): should we cut the new sequence or the original fragments?
  const enzyme = _sequence.assembly()!.enzyme();
  const internalStickyEnds = _sequence.getCuts(enzyme.toJSON()).map((c) => {
    let start = c.position;
    let end = sequtil.mod(start + enzyme.get('offset'), _sequence.length());
    // Reverse start and end for negative offset.
    if (enzyme.get('offset') < 0) {
      [start, end] = [end, start];
    }
    return new asm.goldenGate.StickyEnd(
      _sequence.residueSlice(start, end),
      `${_sequence.name()} at base ${start}`
    );
  });

  // validateStickyEnds returns DryRunStickyEndValidationResult if given dryRun=true but is not typed as such
  return asm.goldenGate.validateStickyEnds(
    junctionStickyEnds,
    internalStickyEnds,
    true
  ) as DryRunStickyEndValidationResult;
}

function stickyEndBases(
  sequence: Sequence,
  upstreamFragment: FragmentResult,
  downstreamFragment: FragmentResult,
  start: number | null,
  end: number | null
): string {
  if (start != null && end != null) {
    return sequence.residueSlice(start, end);
  }
  // Bang operator because Backbone Model.has is, somewhat unintuitively, a nullishness guard
  if (upstreamFragment.has('end_sticky_end')) {
    return upstreamFragment.get('end_sticky_end')!;
  }
  if (downstreamFragment.has('start_sticky_end')) {
    return downstreamFragment.get('start_sticky_end')!;
  }
  return '';
}

class GoldenGateTabOptionsView extends PrimerAssemblyOptionsView {}

class GoldenGateTabView extends PrimerAssemblyTabView {
  override showBinding!: boolean;
  override showHomology!: boolean;

  static override initClass(): void {
    this.prototype.showBinding = false;
    this.prototype.showHomology = false;
  }

  override _getStickyEndsProps(): StickyEndsProps {
    const {errors, warnings} = checkAssembly(this.sequence);
    const stickyEndRanges = asm.goldenGate.stickyEndRanges(this.sequence._sequence());
    const rows = stickyEndRanges.map(({downstreamFragment, end, start, upstreamFragment}) => {
      const bases = stickyEndBases(this.sequence, upstreamFragment, downstreamFragment, start, end);
      return {
        bases,
        downstreamFragment: {
          name: downstreamFragment.parent()?.name || 'deleted',
          color: this.model.lighten(
            colors.shuffledPastelColors[downstreamFragment.collection.indexOf(downstreamFragment)]
          ),
        },
        onClickDownstream: () => {
          if (downstreamFragment.parent() == null) {
            return;
          }
          const parentId = downstreamFragment.parent()!.id;
          FileStates.get().openFolderItem(parentId);
        },
        onClickUpstream: () => {
          if (upstreamFragment.parent() == null) {
            return;
          }
          const parentId = upstreamFragment.parent()!.id;
          FileStates.get().openFolderItem(parentId);
        },
        revcomp: util.revcomp(bases, DNA_COMPLEMENT_TABLE),
        showPrintableSummary: this.model.get('showPrintableSummary'),
        upstreamFragment: {
          name: upstreamFragment.parent()?.name || 'deleted',
          color: this.model.lighten(
            colors.shuffledPastelColors[upstreamFragment.collection.indexOf(upstreamFragment)]
          ),
        },
      };
    });
    return {
      errors,
      finalized: this.sequence.finalized() ?? false,
      rows,
      warnings,
    };
  }

  override remove(): this {
    // @ts-expect-error Backbone views expect to be given `model` explicitly and we are not doing that
    return super.remove();
  }
}

GoldenGateTabView.initClass();

export {GoldenGateTabOptionsView as OptionsView, GoldenGateTabView as TabView};
